<!--use a s sample to build out new route/child route logic-->
<template>
    <v-content v-if="org">
        <v-card>
            <v-card-title>
                {{org.info.fullname}} Profiles
            </v-card-title>
        </v-card>
        <router-view></router-view>
    </v-content>
</template>

<script>
  const PATH = '/a4l' //im lazy and hate writing `"organi....
  import {
    mapState,
    mapActions
  } from 'vuex'
  export default {
    name: "Index",
    data() {
      return {
        menu: true,
        tiles:[
          {to: PATH+'', icon: 'share', name: 'Players'}
        ],
        activating:false
      }
    },
    async created(){
      let f = await this.$store.dispatch('checkPermissions',{permissions:this.permissions,required:this.$route.meta.permissions})
      if(!f){
        this.$router.push('/')
      }
    },
    computed:{
      ...mapState(['permissions', 'org','icons']),
    },

    mounted() {
    },
    methods: {
      ...mapActions(['get','post','putAppOrg'])
    }
  }
</script>

<style scoped>

</style>